import React from 'react';


function AboutMe() {

  return (
    <>
    <div className="containerSecondary" style={{ backgroundColor: '#FFF38A' }}>
      <h1>PAGE NOT FOUND</h1>
    </div>
    </>
  );
}

export default AboutMe;